import { layoutClasses } from 'src/layouts/classes';
import { cn } from '@/lib/utils';

// ----------------------------------------------------------------------

export function Main({ children, className, ...other }: React.HTMLAttributes<HTMLElement>) {
  return (
    <main
      className={cn(layoutClasses.main, 'flex flex-1 flex-col', className)}
      style={{ paddingTop: 'var(--layout-dashboard-content-pt)' }}
      {...other}
    >
      {children}
    </main>
  );
}

// ----------------------------------------------------------------------

type DashboardContentProps = React.HTMLAttributes<HTMLDivElement> & {
  disablePadding?: boolean;
  maxWidth?: string | false;
};

export function DashboardContent({
  className,
  children,
  disablePadding,
  maxWidth = 'xl',
  style,
  ...other
}: DashboardContentProps) {
  const maxWidthClass = maxWidth === 'xl' ? 'max-w-screen-2xl' : maxWidth === 'lg' ? 'max-w-screen-xl' : maxWidth === false ? '' : 'max-w-screen-2xl';

  const baseStyle = disablePadding
    ? undefined
    : {
        paddingBottom: 'var(--layout-dashboard-content-pb)',
        paddingLeft: 'var(--layout-dashboard-content-px)',
        paddingRight: 'var(--layout-dashboard-content-px)',
      };

  return (
    <div
      className={cn(
        layoutClasses.content,
        'mx-auto flex w-full flex-1 flex-col',
        maxWidthClass,
        disablePadding ? 'p-0' : '',
        className,
      )}
      style={{ ...baseStyle, ...style }}
      {...other}
    >
      {children}
    </div>
  );
}
